import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LanguageComponent } from './components/language/language.component';
import { IndexComponent } from './modules/index/pages/index/index.component';
import { ChildrenComponent } from './modules/children/children.component';
import { VirtualMuseumComponent } from './modules/virtual-museum/virtual-museum.component';
import { CollectionComponent } from './modules/collection/collection.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'zh-tw',
    pathMatch: 'full',
    data: { animation: 'root' }
  },
  {
    path: ':lang',
    component: LanguageComponent,
    children: [
      {
        path: '',
        component: IndexComponent,
        data: { animation: 'index' }
      },
      {
        path: 'children',
        component: ChildrenComponent,
        data: { animation: 'children' }
      },
      {
        path: 'virtual-museum',
        component: VirtualMuseumComponent,
        data: { animation: 'virtual-museum' }
      },
      {
        path: 'collection',
        component: CollectionComponent,
        data: { animation: 'collection' }
      }
    ],
    data: { animation: 'language' }
  },
  { path: '**', redirectTo: 'zh-tw' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
